// export const languageCodes = ['EN', 'UK', 'PL', 'RU'] as const;
// export const languageCodesUAInsteadOfUK = ['EN', 'UA', 'PL', 'RU'] as const;
export const languageCodesLowercase = ['en', 'ua', 'pl', 'ru'];
export const languageCodesUppercase = ['EN', 'UA', 'PL', 'RU'];
export const currencyCodes = ['UAH', 'USD', 'EUR', 'PLN', 'CNY', 'JPY', 'GBP', 'THB', 'KZT', 'TRY'];
